export enum EAdyenPaymentType {
  WEB,
  BLIK,
  TOKEN,
  API,
  APPLE_PAY,
  GOOGLE_PAY,
  IDEAL,
  MBWAY,
  BANCONTACT,
  TWINT,
  BANCONTACT_MOBILE,
  MOBILE_PAY,
  SWISH,
}
